import { useAppDispatch, useAppSelector } from 'app/hooks';
import StatusHeader from 'components/common/StatusHeader';
import UseToastComponent from 'components/common/UseToast';
import ja from 'date-fns/locale/ja';
import SubMenuDetailModal from 'features/MenuDetail/pages/SubMenuDetail';
import _ from 'lodash';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Col, ModalProps, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
// import { getDateString } from 'utils';
import MenuDetailModal from '../../MenuDetail/pages/MenuDetail';
import ButtonDeleteMenu from '../components/ButtonDeleteMenu';
import ButtonEditMenu from '../components/ButtonEditMenu';
import Confirmation from '../components/ConfirmDialog';
import ExportCSV, { ExportCsvRef } from '../components/ExportCSV';
import ImportCSVModal from '../components/ImportCSVModal';
import MenuListTable from '../components/MenuListTable';

import FeatureTitleBar from 'components/common/FeatureTitleBar';
import { selectIsEditMode } from 'features/common/editModeSlice';

import { TfiReload } from 'react-icons/tfi';
import MenuListFilter from '../components/MenuListFilter';
import { MAIN_MENU, SUB_MENU } from '../constants';
import menuService from '../menuService';
import { menuListActions, selectIsDeleted, selectIsRestored, selectMenuDetailList } from '../menuSlice';
import { MyButtonRef } from '../models/ButtonProps';
import { Menu, MenuDetail, SearchMenuFilter } from '../models/menu';
import './MenuList.scss';
registerLocale('ja', ja);

function MenuList() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  //selector
  const menuDetails = useAppSelector(selectMenuDetailList);
  const isDeleted = useAppSelector(selectIsDeleted);
  const isRestored = useAppSelector(selectIsRestored);
  const isEditMode = useAppSelector(selectIsEditMode);

  //ref
  const checkboxesRef = useRef<Array<HTMLInputElement>>([]);
  const importCsvModalRef = useRef<ModalProps>(ImportCSVModal);
  const menuDetailModalRef = useRef<ModalProps>(MenuDetailModal);
  const subMenuDetailModalRef = useRef<ModalProps>(SubMenuDetailModal);
  const restoredMenuIdRef = useRef<number>();

  // button ref
  const buttonDeleteRef = useRef<MyButtonRef>(null);
  const buttonEditRef = useRef<MyButtonRef>(null);
  const exportLinkRef = useRef<ExportCsvRef>(null);

  //state ref
  const checkBoxCheckedLengthRef = useRef(0);

  //state
  const [listOfMenuDetail, setListOfMenuDetail] = useState<Array<MenuDetail>>([]);
  const [confirmDeleteMenu, setConfirmDeleteMenu] = useState(false);
  const [listOfMenuDetailChecked, setListOfMenuDetailChecked] = useState<Array<MenuDetail>>([]);
  const [selectedMenuDetail, setSelectedMenuDetail] = useState<MenuDetail>();

  const [filter, setFilter] = useState<SearchMenuFilter>({
    menu_classification: '',
    menu_type_conditions: 0,
    menu_property: 0,

    search_menu_condition: 1,
    search_display_timing: 0,
    search_target_display_group: null,
    search_source_display_control_group: null,

    menu_code: '',
    menu_name: '',

    search_bar_guidance: null,
    search_course: null,
    search_order_limit: null,

    deleted_data: 0,
    menu_pos: '',
    expired_date: new Date(),
    display_limit: 1,
  });

  useEffect(() => {
    if (menuDetails && menuDetails.length > 0) {
      setListOfMenuDetail(menuDetails);
    } else {
      setListOfMenuDetail([]);
    }
    //reset refer checkbox
    resetCheckedMenu();
    checkBoxCheckedLengthRef.current = 0;
    enableDisableBtn();
  }, [menuDetails]);

  //checkbox selected all
  const handleSelectedAll = () => {
    let count = 0;
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox) {
        checkbox.checked = true;
        count++;
      }
    });
    checkBoxCheckedLengthRef.current = count;
    enableDisableBtn();
  };

  //check box unselected all
  const handleUnSelectedAll = () => {
    let count = checkBoxCheckedLengthRef.current;
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox) {
        checkbox.checked = false;
        if (count > 0) count--;
      }
    });
    checkBoxCheckedLengthRef.current = count;
    enableDisableBtn();
  };

  //deleted menu on click button
  const handleBtnDeleteMenu = async () => {
    const menuIds = new Array<number>();
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox && checkbox.checked) {
        menuIds.push(parseInt(checkbox.id));
      }
    });
    const uniq_menu_ids = _.uniq(menuIds);
    const deleted_menu_details = _.filter(listOfMenuDetail, (obj) => _.includes(uniq_menu_ids, obj.id));
    const arrayOfMenuIDs = _.flatMap(deleted_menu_details, (obj) => _.get(obj, 'menu.id'));
    await menuService.deleteMenu(_.uniq(arrayOfMenuIDs)).then((response) => {
      if (response.status === 'success') {
        dispatch(menuListActions.deleteMenuSuccess(true));
        loadMenuData();
      } else {
        console.error('Failed to delete menu:', response.message);
      }
    });
  };

  function loadMenuData() {
    if (menuDetailModalRef.current && typeof menuDetailModalRef.current.onReset === 'function') {
      menuDetailModalRef.current.onReset();
    }
    if (subMenuDetailModalRef.current && typeof subMenuDetailModalRef.current.onReset === 'function') {
      subMenuDetailModalRef.current.onReset();
    }
    dispatch(menuListActions.fetchListOfMenuDetail(filter));
  }

  useEffect(() => {
    loadMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  function handleFilter(data: SearchMenuFilter) {
    setFilter(data);
  }

  //checked menu items on checked box
  const handleCheckedMenu = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked === true) {
      checkBoxCheckedLengthRef.current = ++checkBoxCheckedLengthRef.current;
    } else if (event.target.checked === false) {
      checkBoxCheckedLengthRef.current = --checkBoxCheckedLengthRef.current;
    }
    enableDisableBtn();
  };

  //const reset btn state
  const enableDisableBtn = () => {
    if (checkBoxCheckedLengthRef.current === 0) {
      buttonDeleteRef.current?.disable();
      buttonEditRef.current?.disable();
    } else if (checkBoxCheckedLengthRef.current === 1) {
      buttonDeleteRef.current?.enable();
      buttonEditRef.current?.enable();
    } else if (checkBoxCheckedLengthRef.current > 1) {
      buttonDeleteRef.current?.enable();
      buttonEditRef.current?.disable();
    }
  };

  // reset checked menu items
  const resetCheckedMenu = () => {
    //reset refer checkbox
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox) checkbox.checked = false;
    });
  };

  // handel import csv btn
  const handleImportCsvBtn = () => {
    importCsvModalRef.current.openModal();
  };

  const handleExportCsv = () => {
    const menuIds = new Array<number>();
    checkboxesRef.current.forEach((checkbox) => {
      if (checkbox && checkbox.checked) {
        menuIds.push(parseInt(checkbox.id));
      }
    });
    const lst_detail = listOfMenuDetail.filter((menu_detail: MenuDetail) => menuIds.includes(menu_detail.id));
    setListOfMenuDetailChecked(lst_detail);
  };

  //handleOpenMenuDetailModal
  const handleOpenMenuDetailModal = () => {
    const checkedBoxes = checkboxesRef.current.filter((checkbox) => checkbox && checkbox.checked === true);
    if (checkedBoxes && checkedBoxes.length > 0) {
      const menuDetail = listOfMenuDetail.find((item) => item.id === parseInt(checkedBoxes[0].id));
      setSelectedMenuDetail(menuDetail);
    }
    buttonEditRef.current?.blur();
  };

  const menuDetailCallBack = (objCallBack: {} | undefined) => {
    if (listOfMenuDetail.length > 0) {
      const menu = objCallBack ? (objCallBack as Menu) : undefined;
      if (menu) {
        const updatedItems = [...listOfMenuDetail];
        const index = updatedItems.findIndex((item) => item.menu.id === menu.id);
        updatedItems[index] = {
          ...updatedItems[index],
          menu: {
            ...updatedItems[index].menu,
            note: menu.note,
            img: menu.img,
            menu_properties: menu.menu_properties,
            coupon_classification: menu.coupon_classification,
            display_timing: menu.display_timing,
            display_name: menu.display_name,
            display_name_en: menu.display_name_en,
            display_name_ja: menu.display_name_ja,
            display_name_vi: menu.display_name_vi,
            display_name_ko: menu.display_name_ko,
            display_name_zh_hant: menu.display_name_zh_hant,
            display_name_zh_hans: menu.display_name_zh_hans,
            explanation: menu.explanation,
            explanation_en: menu.explanation_en,
            explanation_ja: menu.explanation_ja,
            explanation_vi: menu.explanation_vi,
            explanation_ko: menu.explanation_ko,
            explanation_zh_hant: menu.explanation_zh_hant,
            explanation_zh_hans: menu.explanation_zh_hans,
            note1: menu.note1,
            note1_en: menu.note1_en,
            note1_ja: menu.note1_ja,
            note1_vi: menu.note1_vi,
            note1_ko: menu.note1_ko,
            note1_zh_hant: menu.note1_zh_hant,
            note1_zh_hans: menu.note1_zh_hans,
            note2: menu.note2,
            note2_en: menu.note2_en,
            note2_ja: menu.note2_ja,
            note2_vi: menu.note2_vi,
            note2_ko: menu.note2_ko,
            note2_zh_hant: menu.note2_zh_hant,
            note2_zh_hans: menu.note2_zh_hans,
          },
        };
        setListOfMenuDetail(updatedItems);
      }
    }
  };

  const handleRestoreMenu = async (id: number) => {
    if (id) {
      dispatch(menuListActions.restoreMenu(id));
      restoredMenuIdRef.current = id;
      loadMenuData();
    }
  };

  // effect
  useEffect(() => {
    if (isDeleted) {
      const menuIds = new Array<number>();
      checkboxesRef.current.forEach((checkbox) => {
        if (checkbox && checkbox.checked) {
          menuIds.push(parseInt(checkbox.id));
        }
      });
      const uniq_menu_ids = _.uniq(menuIds);
      const deleted_menus = listOfMenuDetail.filter((menu_detail: MenuDetail) =>
        uniq_menu_ids.includes(menu_detail.id)
      );
      const lst_detail = listOfMenuDetail.map((menu_detail) => ({
        ...menu_detail,
        delete_flg: deleted_menus.some((obj) => obj.id === menu_detail.id) ? true : menu_detail.delete_flg,
      }));
      setConfirmDeleteMenu(false);
      setListOfMenuDetail(lst_detail);
      //reset refer checkbox
      resetCheckedMenu();
      //set checkbox checked length
      checkBoxCheckedLengthRef.current = checkBoxCheckedLengthRef.current - uniq_menu_ids.length;
      enableDisableBtn();
      dispatch(menuListActions.deleteMenuSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleted]);

  // effect
  useEffect(() => {
    if (isRestored && restoredMenuIdRef.current !== undefined) {
      const lst_detail = listOfMenuDetail.map((menu_detail) => ({
        ...menu_detail,
        delete_flg: menu_detail.menu.id === restoredMenuIdRef.current ? false : menu_detail.delete_flg,
      }));
      setListOfMenuDetail(lst_detail);
      dispatch(menuListActions.restoreMenuSuccess(false));
    }
    restoredMenuIdRef.current = undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestored]);

  // effect
  useEffect(() => {
    loadMenuData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // effect
  useEffect(() => {
    if (selectedMenuDetail !== undefined) {
      // const expired_date = getDateString(expiredDateRef.current);
      if (selectedMenuDetail?.menu.type === MAIN_MENU) {
        menuDetailModalRef.current.openModal(selectedMenuDetail, filter.expired_date);
      } else if (selectedMenuDetail?.menu.type === SUB_MENU) {
        subMenuDetailModalRef.current.openModal(selectedMenuDetail, filter.expired_date);
      } else {
        menuDetailModalRef.current.openModal(selectedMenuDetail, filter.expired_date);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMenuDetail?.id]);

  // effect
  useEffect(() => {
    if (listOfMenuDetailChecked.length > 0) {
      if (exportLinkRef.current) {
        exportLinkRef.current?.onClick();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listOfMenuDetailChecked]);

  const handleOnCloseModal = () => {
    setSelectedMenuDetail(undefined);
    loadMenuData();
  };

  return (
    <>
      {confirmDeleteMenu && (
        <Confirmation
          okLabel={t('MenuList.DialogConfirm.btn_save')}
          cancelLabel={t('MenuList.DialogConfirm.btn_cancel')}
          title={t('MenuList.DialogConfirm.title')}
          confirmationMessage={t('MenuList.DialogConfirm.message')}
          onHide={() => setConfirmDeleteMenu(false)}
          proceed={handleBtnDeleteMenu}
          enableEscape={false}
        />
      )}
      <ExportCSV data={listOfMenuDetailChecked ?? []} ref={exportLinkRef} />
      <ImportCSVModal ref={importCsvModalRef} />
      <MenuDetailModal
        ref={menuDetailModalRef}
        menuCallBack={menuDetailCallBack}
        onMenuModalClose={handleOnCloseModal}
      />
      <UseToastComponent />
      <div className="page-wrapper">
        <div className="page-header">
          <StatusHeader onAction={() => history.push('/')} />
        </div>
        <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
          <div className="page-content d-flex flex-column">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-lg-12">
                <div className="mb-2">
                  <div className="mb-3">
                    <FeatureTitleBar title={t('MenuList.Filter.menu_list')} />
                  </div>
                  <MenuListFilter onFilter={handleFilter} />
                </div>
              </div>
            </div>
            <Row className="mb-2">
              <Col sm={4} lg={4}>
                <div className="d-inline">
                  <button
                    type="button"
                    onClick={handleSelectedAll}
                    style={{ textDecoration: 'none', minWidth: '0px' }}
                    className="btn btn-link"
                  >
                    {t('MenuList.Button.select_all')}
                  </button>
                  /
                  <button
                    type="button"
                    onClick={handleUnSelectedAll}
                    style={{ textDecoration: 'none', minWidth: '0px' }}
                    className="btn btn-link"
                  >
                    {t('MenuList.Button.cancel_all')}
                  </button>
                  <span className="ps-2 pe-2"></span>
                  <button className="btn btn-link" style={{ textDecoration: 'none' }} onClick={loadMenuData}>
                    <span className="bg-primary rounded-circle d-inline-flex p-2">
                      <TfiReload size={12} color="#fff" />
                    </span>
                    {t('MenuList.Button.reload')}
                  </button>
                </div>
              </Col>
              <Col sm={8} lg={8} className="d-flex justify-content-end">
                <ButtonEditMenu ref={buttonEditRef} proceed={handleOpenMenuDetailModal} />
                <span className="ps-2 pe-2"></span>
                <ButtonDeleteMenu
                  proceed={() => {
                    setConfirmDeleteMenu(true);
                  }}
                  ref={buttonDeleteRef}
                />
                <span className="ps-2 pe-2"></span>
                <button type="button" onClick={handleExportCsv} className="btn btn--dark-green btn-wrap">
                  <span className="d-inline-block align-middle">{t('MenuList.Button.export_csv')}</span>
                </button>
                <span className="ps-2 pe-2"></span>
                <button type="button" className="btn btn--dark-green" onClick={handleImportCsvBtn}>
                  {t('MenuList.Button.import_csv')}
                </button>
              </Col>
            </Row>
            <MenuListTable
              menuDetails={listOfMenuDetail}
              handleCheckBox={handleCheckedMenu}
              checkboxesRef={checkboxesRef}
              handleRestore={handleRestoreMenu}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default MenuList;
